// extracted by mini-css-extract-plugin
export default {"wrapper":"Error404_wrapper__oWKQW"};